/** @jsxImportSource @emotion/react */
import React from 'react';
import {
  NewMessageContainer,
  NewMessageInner,
  NewMessageHeaderRow,
  Badge,
  BadgeDot,
  BadgeText,
  TimeText,
  MessagePreview,
  ActionsRow,
  ViewConversationButton,
} from './new-message.styled';
import { useNewMessage } from './new-message.hooks';
// import { ConversationListenButton } from '../conversation/listen-button/listen-button';

export type NewMessageProps = {
  previewText: string;
  dateLabel: string;
  onOpenConversation: () => void;
  isFromMe?: boolean;
  audioUrl?: string | null;
  /** Opens conversation and starts playing the message audio from there */
  onListenClick?: () => void;
};

export const NewMessage: React.FC<NewMessageProps> = ({
  previewText,
  dateLabel,
  onOpenConversation,
  isFromMe = false,
  // audioUrl,
  // onListenClick,
}) => {
  const { handleViewConversation } = useNewMessage({ onOpenConversation });

  // const hasAudio = !!audioUrl;

  // const handleListenStart = React.useCallback(() => {
  //   onListenClick?.();
  // }, [onListenClick]);

  // // Noop handlers — the button stays in collapsed (idle) state only
  // const noop = React.useCallback(() => {}, []);

  return (
    <NewMessageContainer>
      <NewMessageInner onClick={handleViewConversation} style={{ cursor: 'pointer' }}>
        {/* Row 1: Badge + time */}
        <NewMessageHeaderRow>
          <Badge>
            {!isFromMe && <BadgeDot />}
            <BadgeText>{isFromMe ? 'My reflections' : 'New from Chris'}</BadgeText>
          </Badge>

          <TimeText>{dateLabel}</TimeText>
        </NewMessageHeaderRow>

        {/* Row 2: Text preview (2 lines, ellipsis) */}
        <MessagePreview>{previewText}</MessagePreview>

        {/* Row 3: Actions */}
        <ActionsRow>
          <ViewConversationButton
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleViewConversation();
            }}
          >
            View full conversation
          </ViewConversationButton>

          {/* {hasAudio && (
            <div onClick={(e) => e.stopPropagation()}>
              <ConversationListenButton
                onStart={handleListenStart}
                onTogglePause={noop}
                onSeek={noop}
                loading={false}
                playing={false}
                paused={false}
                hasAudio
                durationMs={0}
                progressPct={0}
                elapsedMs={0}
                title="Listen"
                direction="rtl"
              />
            </div>
          )} */}
        </ActionsRow>
      </NewMessageInner>
    </NewMessageContainer>
  );
};
